<template>
  <v-container fluid justify-start>
    <!-- Data Table -->
    <v-data-table
      :headers="headers"
      :items="activities"
      :search="search"
      :custom-filter="descriptionFilter"
      :loading="isLoading"
      item-key="id"
      :no-data-text="noDataText"
      class="elevation-2"
      >
      <v-progress-linear slot="progress" :color="appColor_Progress" indeterminate></v-progress-linear>
      
      <template v-slot:top>

        <!-- Header Toolbar -->
        <v-toolbar dense flat dark :color="appColor_Medium">
          
          <app-back-button v-bind:color="appColor_Dark" />

          <!--<v-icon large class="mr-2" :color="appColor_Abby">games</v-icon>-->
          <v-toolbar-title>Abby Activities</v-toolbar-title>

          <v-spacer />

          <!-- Edit Dialog -->
          <v-toolbar-items>
            <v-dialog
              v-model="editDialog"
              max-width="400px"
              :persistent="true"
              >
              <loading slot="layout" :active.sync="isLoadingDialog" :can-cancel="false" loader="dots" :color="appColor_Progress"></loading>
              <template v-slot:activator="{ on }">
                <v-btn v-if="isSmallDevice" slot="activator" small :color="appColor_Dark" dark class="mb-1 mt-0 mr-0 elevation-0" v-on="on">New</v-btn>
                <v-btn v-else slot="activator" :color="appColor_Dark" class="mb-1 mt-0 mr-0 elevation-0" v-on="on">Create Activity</v-btn>
              </template>
              <v-card>
                <v-toolbar dense dark flat :color="appColor_Medium">
                  <v-toolbar-title><v-icon>edit</v-icon> {{ formTitle }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pa-0 pt-2 ma-0">
                  <v-container grid-list-md class="pt-0 pb-0">
                    <form>
                      <v-layout wrap>
                        <v-flex xs12 sm12 md12>
                          <v-text-field
                            v-model="editedActivity.description"
                            label="Description"
                            v-validate="'required|max:50'"
                            :error-messages="errors.collect('description')"
                            data-vv-name="description"
                            @keyup="descriptionChanged"
                            ref="description"
                          >
                          </v-text-field>
                          <v-text-field
                            v-model="editedActivity.url"
                            label="Url Segment"
                            disabled
                          >
                          </v-text-field>
                        </v-flex>
                      </v-layout>
                    </form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click.native="closeDialog">Cancel</v-btn>
                  <v-btn :color="appColor_Medium" text @click.native="save">Save</v-btn>
              </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar-items>
        </v-toolbar>

        <v-row class="mx-0">

          <!-- Next Update -->
          <v-col cols="12" md="1">
            <v-text-field
              v-model="nextUpdate"
              hide-details
              :class="filterClass"
              label="Next Update"
              disabled
            >
            </v-text-field>
          </v-col>
          
          <!-- Search -->
          <v-col cols="12" md="5">
            <v-text-field
              v-model="search"
              append-icon="search "
              label="Search"
              single-line
              hide-details
              clearable
              :disabled="isLoading"
              :class="filterClass" 
              >
            </v-text-field>
          </v-col>

          <!-- Download / Release Buttons -->
          <v-col cols="12" md="6">

            <v-btn
              outlined
              :disabled="isLoading || !isActivitySelected"
              @click="getUpdateZip"
              class="mt-4"
              >Download Zip
              <v-icon class="ml-2">cloud_download</v-icon>
            </v-btn>

            <v-btn
              outlined
              color="green"
              class="ml-2 mt-4"
              @click="$refs.release.click()"
              :disabled="isLoading || !isActivitySelected"
              >
              Release Update
              <v-icon class="ml-2">cloud_upload</v-icon>
            </v-btn>
            <input
              v-show="false"
              type="file"
              ref="release"
              accept=".zip"
              @change="fileChanged()"
            />

          </v-col>
        </v-row>
        
      </template>
      
      <template slot="item" slot-scope="data">
        <div class='my-border'>{{data.item.name}}</div>
      </template>

      <template v-slot:body="{ items }">
        <tbody>
          <tr :class="key === selectedRow ? 'custom-highlight-row' : ''" v-for="(item, key) in items" :key="item.name">
            <td>
              <v-radio-group v-model="ids">
                <v-radio :value="item.id" @click="rowSelect(key)"></v-radio>
              </v-radio-group>
            </td>
            <td><span :class="getRowFont(item)">{{ item.id }}</span></td>
            <td>
              <span :class="getRowFont(item)">{{ item.description }}</span>
            </td>
            <td><span :class="getRowFont(item)">{{ item.url }}</span></td>
            <td><span :class="getRowFont(item)"><app-date :date="item.releaseDate" :format="'MMM DD, YYYY'"/></span></td>
            <td><span :class="getRowFont(item)"><app-date :date="item.updateDate" :format="'MMM DD, YYYY'"/></span></td>
            <td>
              <span class="text-center">
                <v-icon @click="edit(item)">edit</v-icon>
              </span>
            </td>
          </tr>
        </tbody>
      </template>

    </v-data-table>

    <!-- Confirm With Comment -->
    <v-dialog v-model="commentDialog" max-width="400px" persistent>
      <v-card>
        <v-toolbar dark flat color="green">
          <v-toolbar-title><v-icon class="pr-2">help</v-icon>{{ confirmTitle }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text v-html="confirmHtml" class="pt-4 pb-0"></v-card-text>
        <v-card-text>
          <v-container grid-list-md class="pa-0 pt-4">
            <form>
              <v-textarea
                v-model="comment"
                outlined
                label="Description of changes"
                auto-grow
                hide-details
                ref="comment"
                >
              </v-textarea>
            </form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="commentDialog = false">No</v-btn>
          <v-btn text color="info" @click="uploadWithComment" :disabled="!isComment">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import appService from '@/app.service'
import { AppColor } from '@/config.js'
import AppDate from '@/components/App/AppDate'
import AppBackButton from '@/components/App/AppBackButton'

export default {
  name: 'ActivityManager',
  components: {
    AppDate,
    AppBackButton
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {

      // colors
      appColor_Medium: AppColor.Medium,
      appColor_Dark: AppColor.Dark,
      appColor_DeleteButton: AppColor.DeleteButton,
      appColor_Progress: AppColor.Progress,
      appColor_Abby: AppColor.KioskTypeAbby,
      appColor_Selected: AppColor.Selected,

      isLoading: true,
      isSaving: false,
      isLoadingDialog: false,
      editDialog: false,
      commentDialog: false,
      search: '',
      selectedRow: null,
      ids: [],
      activities: [],
      nextUpdate: null,
      zipFile: null,
      confirmTitle: null,
      confirmHtml: null,
      comment: null,
      headers: [
        {
          width: '5%',
          class: 'pr-0'
        },
        {
          text: 'ID',
          value: 'id',
          align: 'left',
          width: '5%',
          class: 'pr-0'
        },
        {
          text: 'Description',
          value: 'description',
          align: 'left',
          width: '20%',
          class: 'pr-0'
        },
        {
          text: 'Url Segment',
          value: 'url',
          align: 'left',
          width: '30%',
          class: 'pr-0'
        },
        {
          text: 'Released',
          value: 'releaseDate',
          align: 'left',
          width: '15%',
          class: 'pr-0'
        },
        {
          text: 'Updated',
          value: 'updateDate',
          align: 'left',
          width: '15%',
          class: 'pr-0'
        },
        {
          align: 'left',
          width: '5%'
        }
      ],
      editedIndex: -1,
      editedActivity: {
        id: -1,
        responseTypeId: -1,
        description: null,
        url: null,
        createDate: null,
        releaseDate: null,
        updateDate: null
      },
      defaultActivity: {
        id: -1,
        responseTypeId: -1,
        description: null,
        url: null,
        createDate: null,
        releaseDate: null,
        updateDate: null
      },
      dictionary: {
        custom: {
          description: {
            required: () => 'Descriprion is required',
            max: 'Description must be 50 characters or less'
          }
        }
      }
    }
  },
  computed: {
    noDataText () {
      if (this.isLoading) return 'One moment...'

      return this.activities.length === 0
        ? 'No activities found'
        : ''
    },
    formTitle () {
      return this.editedActivity.id < 0 ? 'New Activity' : 'Edit Activity'
    },
    filterClass () {
      return this.$vuetify.breakpoint.name === 'lg' 
        || this.$vuetify.breakpoint.name === 'md' 
        ? 'ml-0'
        : 'ml-0'
    },
    isActivitySelected () {
      return this.selectedRow !== null
    },
    selectedActivity () {
      if (this.selectedRow === null) return { id: 0 }
      return this.activities[this.selectedRow]
    },
    isComment () {
      if (this.comment === null) return false
      return this.comment.trim().length > 0
    }
  },
  methods: {
    loadData () {
      const self = this
      self.isLoading = true
      appService.getAbbyActivities().then(data => {
        if (data.errorSeverity > 0) {
          self.handleError(data)
        } else {
          self.activities = self.buildArray(data.activities)
          self.nextUpdate = data.nextUpdate
        }
        self.isLoading = false
      }).catch(e => { self.handleCriticalError(e) })
    },

    buildArray (activities) {
      return activities.map(a => { return {
        id: a.id,
        description: a.description,
        url: a.url,
        updateLevel: a.updateLevel,
        responseTypeId: a.responseTypeId,
        createDate: a.createDate,
        releaseDate: a.releaseDate,
        updateDate: a.updateDate
      }})
    },

    edit (item) {
      const self = this
      self.isLoadingDialog = true
      self.editedIndex = self.activities.indexOf(item)
      self.editedActivity = Object.assign({}, item)
      self.editDialog = true
      setTimeout(() => {
        self.isLoadingDialog = false
      }, 100)
    },

    save () {
      const self = this
      self.$validator.validateAll().then(valid => {
        if (valid) {
          const isEditMode = self.editedIndex > -1
          self.isSaving = true

          if (isEditMode) {
            var editedActivity = self.activities[self.editedIndex]
            Object.assign(editedActivity, self.editedActivity)
            const activityModel = self.getModel(editedActivity, true)
            appService.updateAbbyActivity(editedActivity.id, activityModel).then((data) => {
              if (data.errorSeverity !== null) {
                self.handleError(data)
              }
              self.isSaving = false
              self.closeDialog()
            }).catch(e => { self.handleCriticalError(e) })
          } else {
            const activityModel = self.getModel(self.editedActivity, false)
            appService.addAbbyActivity(activityModel).then((data) => {
              if (data.errorSeverity !== null) {
                self.handleError(data)
              } else {
                self.editedActivity.id = data.activity.id
                self.editedActivity.responseTypeId = data.activity.responseTypeId
                self.editedActivity.createDate = data.activity.createDate
                self.activities.unshift(self.editedActivity)
              }
              self.isSaving = false
              self.closeDialog()
            }).catch(e => { self.handleCriticalError(e) })
          }
        }
      })
    },

    getModel (a, isEditMode) {
      var model

      if (isEditMode) {
        model = {
          id: a.id,
          description: a.description,
          url: a.url,
          createDate: a.createDate
        }
      } else {
        model = {
          description: a.description,
          url: a.url
        }
      }
      return model
    },

    rowSelect(idx) {
      this.selectedRow = idx;
    },

    getUpdateZip () {
      const self = this
      const a = self.selectedActivity
      const activities = [{
        id: a.id,
        responseTypeId: a.responseTypeId,
        description: a.description,
        releaseDate: a.releaseDate
      }]
      appService.getAbbyActivityUpdateZip(self.nextUpdate, activities)
        .then(() => {})
        .catch(e => { self.handleCriticalError(e) })
    },

    release () {
      const self = this

      self.confirmTitle = self.selectedActivity.releaseDate !== null
        ? 'Release Update?'
        : 'Release New Activtiy?'

      self.confirmHtml =  `Target: <b>${self.selectedActivity.description}</b></br>` +
                      `Package: <b>${self.nextUpdate}.zip</b>`

      // activity updates for existing activities require a comment from the developer
      if (self.selectedActivity.releaseDate !== null) {
        self.commentDialog = true
      } else {
        self.comment = 'Initial release' 
        self.$confirm.show({
          title: self.confirmTitle,
          text: self.confirmHtml,
          formColor: 'green',
          onConfirm: () => {
            self.uploadRelease()
          },
          onCancel: () => {
            self.resetFileInput()
          }
        })
      }
    },

    uploadRelease () {
      const self = this

      self.commentDialog = false

      let formData = new FormData()
      formData.append('file', self.zipFile)
      formData.append('comment', self.comment)
      formData.append('level', self.nextUpdate)
      formData.append('typeId', self.selectedActivity.id)

      self.$upload.execute({
        formData: formData,
        url: 'abbyactivities/release',
        fileCount: 1,
        onComplete: (data) => {

          if (data.errorSeverity > 0) {
            self.handleError(data)
          } else {
            self.resetFileInput()
            self.comment = null
            const index = self.activities.findIndex(i => i.id === self.selectedActivity.id)
            if (index >= 0) {
              self.activities[index].releaseDate = data.releaseDate
              self.activities[index].updateDate = data.updateDate
              self.nextUpdate = data.nextUpdate
            }
          }
        }
      })
    },

    resetFileInput () {
      this.$refs.release.type = 'hidden'
      this.$refs.release.type = 'file'
    },

    uploadWithComment () {
        this.commentDialog = false
        if (this.isComment) {
          this.uploadRelease()
        }
    },

    closeDialog () {
      const self = this
      self.editDialog = false
      setTimeout(() => {
        self.resetEditedActivity()
        self.isLoadingDialog = false
      }, 300)
    },

    resetEditedActivity () {
      this.editedActivity = Object.assign({}, this.defaultActivity)
      this.editedIndex = -1
      this.$validator.reset()
    },

    descriptionFilter (value, search, item) {
      return value != null &&
        search != null &&
        item.description.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1
    },

    handleError (result) {
      this.$error.show({
        title: result.errorSeverity === 0
                      ? 'Validation Failed'
                      : 'Internal Error',
        text: result.errorMessage,
        severity: result.errorSeverity
      })
    },

    getRowFont (item) {
      return item.id === this.selectedActivity.id
        ? 'text-left font-weight-medium'
        : 'text-left'
    },

    // events

    fileChanged () {
      const file = this.$refs.release.files[0]
      const nextFilename = `${this.nextUpdate}.zip`

      if (file.name !== nextFilename) {
        this.$error.show({
          title: 'Invalid Filename',
          text: `Filename not valid.<br/><br/>Expected a zip file with the name <b>${nextFilename}</b>.`,
          severity: 0
        })
      } else {
        this.zipFile = file
        this.release()
      }
    },

    descriptionChanged () {
      const route = this.editedActivity.description.replace(/\s/g,'')
      this.editedActivity.url = `${route}/index.html`
    }
  },
  created() {
    this.loadData()
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
  },
  watch: {
    editDialog (val) {
      if (val) {
        const self = this
        if (self.editedIndex < 0) {
          self.selectedRow = null
          self.ids = []
        }
        setTimeout(() => {
          // set focus to description input in the edit dialog
          self.$refs.description.focus()
        }, 300)
      } else {
        this.closeDialog()
      }
    },
    commentDialog (val) {
      if (val) {
        const self = this
        setTimeout(() => {
          // set focus to comment textarea in the comment dialog
          self.$refs.comment.focus()
        }, 300)
      } else {
        this.resetFileInput()
      }
    }
  }
}
</script>

<style scoped>
.custom-highlight-row{
  background-color: rgb(255, 255, 144);
}
</style>
